module.exports = __webpack_public_path__ + "img/icon-install-primary.150f7f33.svg";